import { render, staticRenderFns } from "./VacancyListCard.htm?vue&type=template&id=c9b2007a&scoped=true&"
import script from "./VacancyListCard.ts?vue&type=script&lang=js&"
export * from "./VacancyListCard.ts?vue&type=script&lang=js&"
import style0 from "./VacancyListCard.scss?vue&type=style&index=0&id=c9b2007a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9b2007a",
  null
  
)

export default component.exports